import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

/** Collapsed-sidebar mark: a Khonology-red "K". */
export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      aria-label="Khonology"
    >
      <text
        x="16"
        y="25"
        textAnchor="middle"
        fontFamily="Poppins, Helvetica Neue, Arial, sans-serif"
        fontWeight="600"
        fontSize="26"
        fill="#C42727"
      >
        K
      </text>
    </svg>
  );
};
